import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Connects to data-controller="sortable"
export default class extends Controller {
  static targets = ["list", "template"];

  connect() {
    this.sortable = new Sortable(this.listTarget, {
      animation: 150,
      handle: ".btn-primary.cursor-grab",
      onEnd: (event) => {
        this.updateIndexes();
        this.stopDrag(event);
      },
    });
  }

  addItem(event) {
    event.preventDefault();

    // Clone the template and replace placeholder
    const newIndex = Date.now(); // Use a unique index to prevent conflicts
    const content = this.templateTarget.innerHTML.replace(/X-ID/g, newIndex);

    this.listTarget.insertAdjacentHTML("beforeend", content);
    this.updateIndexes();
  }

  remove(event) {
    event.preventDefault();

    // Mark the item for destruction instead of removing it from DOM immediately
    const item = event.target.closest("[data-sortable-target='item']");
    const destroyInput = item.querySelector('input[name*="[_destroy]"]');
    if (destroyInput) destroyInput.value = "1";

    // Optionally hide the item to keep animation smooth
    item.style.display = "none";
    this.updateIndexes();
  }

  startDrag(event) {
    event.target.classList.add("dragging");
  }

  stopDrag(event) {
    event.target.classList.remove("dragging");
  }

  updateIndexes() {
    this.listTarget
      .querySelectorAll("[data-sortable-target='item']")
      .forEach((item, index) => {
        // Find the hidden "sort" input inside this item
        const sortInput = item.querySelector("input[name*='[sort]']");
        if (sortInput) {
          sortInput.value = index; // Update the value with the new position/index
        }
      });
  }
}
